import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.number.constructor";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es7.promise.finally";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import mean from 'lodash/mean';
import { mapState } from 'vuex';
import formMixin from '../formMixin';
export default {
  name: 'NiotaClassicApplicationsMap',
  mixins: [formMixin],
  props: {
    applicationObj: {
      type: Object,
      required: true
    },
    interactiveMap: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      csvFormDialog: false,
      isLoadingDevices: true,
      devicesPlain: [],
      devicesMarkers: [],
      fullScreenMap: false
    };
  },
  computed: _objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])),
  watch: {
    applicationObj: debounce(function () {
      // Items have already been requested
      if (this.isFetchingDevices) {
        return;
      }

      this.getApplicationDevicesPlain();
    }, 500)
  },
  mounted: function mounted() {
    this.getApplicationDevicesPlain();
  },
  methods: {
    getApplicationDevicesPlain: function getApplicationDevicesPlain() {
      var _this = this;

      // console.log('Fetching devices.....');
      if (this.isFetchingDevices) {
        return;
      }

      this.isFetchingDevices = true;
      this.isLoadingDevices = true;
      return NiotaClassicApiService.getApplicationDevicesPlain(this.$route.params.applicationId).then(function (res) {
        _this.devicesPlain = res.data.devices;

        _this.addDeviceMarker();
      }).catch(function (error) {
        console.error('Error:', error);
      }).finally(function () {
        _this.isFetchingDevices = false;
        _this.isLoadingDevices = false;
      });
    },
    addDeviceMarker: function addDeviceMarker() {
      var _this2 = this;

      var maxMarker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
      var devices = this.devicesPlain;
      devices.length > maxMarker ? devices = devices.slice(0, maxMarker) : devices;
      devices.forEach(function (device) {
        var mediumValues = {
          rssi: 0,
          lsnr: 0
        };
        var popUpMessage = "<b>Device:</b> ".concat(device.title);
        var lat = device.lat;
        var lng = device.lon;

        if (!isNaN(lat) && !isNaN(lng)) {
          if (device.packets.length) {
            // Check if there is a server_data and gwrx record
            var firstPacket = device.packets[0];
            var isActilityDevice = firstPacket.source && firstPacket.source.toLowerCase() === 'actility';

            if (get(firstPacket, 'source_data.server_data') || isActilityDevice) {
              // for actility devices
              if (isActilityDevice) {
                mediumValues = _this2.calcualteActilityDevicesRx(firstPacket.signal);
              } else {
                mediumValues = _this2.calcualteMediumReceptionValues(firstPacket.source_data.server_data.gwrx);
              }
            } else {
              // No Server-Data and GWRX, set to fix value
              mediumValues.rssi = -60;
            }

            popUpMessage = "".concat(popUpMessage, "<br /><b>RSSI:</b> ").concat(mediumValues.rssi) + "<br /><b>SNR:</b> ".concat(mediumValues.lsnr);
          }

          var marker = {
            message: popUpMessage,
            // coordinates: {
            //   lat: Number(lat),
            //   lon: Number(lng),
            // },
            coordinates: [Number(lng), Number(lat)]
          };

          _this2.devicesMarkers.push(marker);
        }
      });

      if (!this.devicesMarkers.length) {
        this.$emit('hide-map', true);
      }
    },
    calcualteActilityDevicesRx: function calcualteActilityDevicesRx(signal) {
      return {
        rssi: signal.rssi,
        lsnr: signal.snr
      };
    },
    calcualteMediumReceptionValues: function calcualteMediumReceptionValues(gwrx) {
      var rssis = [];
      var lsnrs = [];
      gwrx.forEach(function (gw) {
        rssis.push(gw.rssi);
        lsnrs.push(gw.lsnr);
      });
      return {
        rssi: mean(rssis),
        lsnr: mean(lsnrs)
      };
    }
  }
};